<template>
<div class="users-table-detail-row">
    <div class="gray-message" v-if="facility === null">User does not own a facility.</div>

    <div v-if="facility !== null">
        <div class="gray-message mb-2">Facility Information:</div>

        <div class="flex">
            <div class="flex">
                <strong>Address:</strong>
                <div class="flex fd-c ml-3">
                    <span>{{ facility.address }}</span>
                    <span>{{ facility.city }}, {{ facility.state }} {{ facility.zip_code }}</span>
                    <a class="d-ib fs-09" :href="getAddressMapUrl()" target="_blank">
                        Open in Google Maps
                        <span><i class="material-icons">launch</i></span>
                    </a>
                </div>
            </div>

            <div class="as-c gray-divider ml-5 mr-5">&nbsp;</div>

            <div class="flex">
                <strong>Contact:</strong>
                <div class="flex fd-c ml-3">
                    <span>{{ facility.contact_name }}</span>
                    <a :href="'mailto:' + facility.email">{{ facility.email }}</a>
                    <span v-html="formatPhoneFunc(facility.phone)"></span>
                    <span v-if="facility.fax !== null" v-html="formatPhoneFunc(facility.fax)"></span>
                </div>
            </div>

            <div v-if="!rowData.has_changed_password" class="flex">
                <div class="as-c gray-divider ml-5 mr-5">&nbsp;</div>

                <div class="flex">
                    <strong>Send Password:</strong>
                    <div class="flex fd-c ml-3">
                        <a :href="password_link_path">Email</a>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>
</template>

<script>
import { formatPhone } from "../utilities/columns"

export default {
    name: "users-table-detail-row",

    props: {
        rowData: {
            required: true,
            type: Object
        },

        rowIndex: {
            type: Number
        }
    },

    data () {
        return {
            facility: this.rowData.facility,
            formatPhoneFunc: formatPhone.bind(this)
        }
    },

    computed: {
        password_link_path () {
            const subject = encodeURIComponent(`Password access for facility ${this.facility.account_name} in Audit Letter Program`)
            const body = encodeURIComponent([
                `Hi, ${this.rowData.real_name},`,
                "",
                "Congratulations and welcome to your audit letter program! Below you will find the username and password to your customized portal. Once logged in, you can modify your password by clicking on the profile button at the top of the screen.",
                "",
                `Username: ${this.rowData.username}`,
                `Password: ${this.rowData.original_password}`,
                "",
                "Upon entering the portal you will be prompted to remove any tenants that have moved out. Please complete this step as your first action.",
                "",
                "We look forward to assisting you on this process!",
                "",
                "Portal: https://tiaudit.com"
            ].join("\n"))

            const path = `mailto:${this.rowData.email}?subject=${subject}&body=${body}`

            return path
        }
    },

    methods: {
        /**
         * Get a Google Maps URL for an address in facility data.
         *
         * @param object data Facility data object
         *
         * @return string
         */
        getAddressMapUrl () {
            const base = "https://www.google.com/maps/place"
            const query = `${this.facility.address.replace(/\s/g, "+")},+${this.facility.city.replace(/\s/g, "+")},+${this.facility.state}+${this.facility.zip_code}`

            return `${base}/${query}`
        }
    }
}
</script>



// WEBPACK FOOTER //
// src/components/UsersTableDetailRow.vue